'use client';

import { useEffect } from 'react';
import { measureSearchWait } from '@/utility/tracking/searchWaitTime';

type SearchWaitMarkerProps = {
  noResults: boolean;
};

/**
 * Ends the search wait time of a search-bar submit once this page is on screen. Rendered on every
 * page a search-bar submit can lead to: the PLP (and its no-results page), the license showroom and
 * the CYO product-type detail page.
 */
export const SearchWaitMarker = ({ noResults }: SearchWaitMarkerProps) => {
  // No dependency list on purpose: a search between two pages of the same route can keep this
  // component mounted with the same props, and it only re-renders when a new page payload commits.
  // Without a pending submit the call is a no-op, so the initial page load and unrelated renders
  // measure nothing.
  useEffect(() => {
    measureSearchWait(noResults);
  });

  return null;
};
